import { render, staticRenderFns } from "./ImportTableBeneficiary.vue?vue&type=template&id=3ff65bf7"
import script from "./ImportTableBeneficiary.vue?vue&type=script&lang=js"
export * from "./ImportTableBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports